import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Container } from '@/components/ui/Container';
import { Button } from '@/components/ui/Button';
import { PricingCard } from '@/components/ui/PricingCard';
import { PRICING_PLANS } from '@/utils/constants';

export const PricingPreview: FC = () => {
  const displayPlans = PRICING_PLANS.filter(p => p.category === 'claude').slice(0, 3);

  return (
    <section className="py-24 bg-white">
      <Container>
        {/* 区块标题 */}
        <div className="text-center mb-14 max-w-xl mx-auto">
          <h2
            className="font-bold text-apple-dark mb-4"
            style={{ fontSize: 'clamp(1.875rem, 4vw, 3rem)', lineHeight: 1.1, letterSpacing: '-0.025em' }}
          >
            选择适合您的方案
          </h2>
          <p className="text-lg text-apple-gray mb-6">
            灵活月付，随时调整，无长期合约束缚
          </p>
          <span className="inline-flex items-center gap-1.5 px-3.5 py-1 rounded-full bg-[#FFF3E0] text-[#E65100] text-sm font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E65100] inline-block" />
            限时优惠活动进行中
          </span>
        </div>

        {/* 定价卡片 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          {displayPlans.map((plan) => (
            <PricingCard key={plan.id} plan={plan} compact />
          ))}
        </div>

        {/* 流量包高亮卡片 */}
        <div className="rounded-apple-lg overflow-hidden border border-[#34C759]/30 bg-[#F0FFF4] mb-10 shadow-apple-sm">
          <div className="p-8 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex-1">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-[#34C759] text-white text-xs font-semibold mb-4">
                超值流量包
              </span>
              <h3
                className="font-bold text-apple-dark mb-2 text-xl"
                style={{ letterSpacing: '-0.02em' }}
              >
                不想月付？试试流量包
              </h3>
              <p className="text-[15px] text-apple-gray mb-5">
                ¥300 购买 $300 流量额度，60 天有效期，按需使用，灵活自由
              </p>
              <ul className="grid grid-cols-2 gap-2">
                {['支持 Claude 全模型', '不限并发终端', '适合临时项目', '性价比超高'].map((text) => (
                  <li key={text} className="flex items-center gap-2 text-sm text-apple-gray">
                    <svg className="w-4 h-4 text-[#34C759] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    {text}
                  </li>
                ))}
              </ul>
            </div>

            {/* 价格展示 */}
            <div className="text-center flex-shrink-0">
              <div className="bg-white rounded-apple shadow-apple p-6 mb-4 min-w-[140px]">
                <div
                  className="font-bold text-apple-dark mb-0.5"
                  style={{ fontSize: '2.5rem', letterSpacing: '-0.03em' }}
                >
                  ¥300
                </div>
                <div className="text-sm text-apple-gray">一次性支付</div>
                <div className="border-t border-apple-separator mt-3 pt-3">
                  <div className="font-semibold text-[#34C759]">$300 流量</div>
                  <div className="text-xs text-apple-gray">60 天有效</div>
                </div>
              </div>
              <Button
                as={Link}
                to="/pricing"
                variant="secondary"
                className="bg-[#1D1D1F] text-white w-full justify-center"
              >
                了解详情
              </Button>
            </div>
          </div>
        </div>

        {/* 查看全部 */}
        <div className="text-center">
          <Button as={Link} to="/pricing" variant="outline" size="lg">
            查看完整方案对比
          </Button>
        </div>
      </Container>
    </section>
  );
};
